import { render, staticRenderFns } from "./ButtonTop.vue?vue&type=template&id=0ca4bb74&"
import script from "./ButtonTop.vue?vue&type=script&lang=js&"
export * from "./ButtonTop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports